var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3.49596,
    fill: "#FAF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92188 10.4714C6.92188 10.0231 7.09994 9.59323 7.4169 9.27628C7.73386 8.95932 8.16375 8.78125 8.612 8.78125H22.133C22.5812 8.78125 23.0111 8.95932 23.3281 9.27628C23.645 9.59323 23.8231 10.0231 23.8231 10.4714V18.922C23.8231 19.3702 23.645 19.8001 23.3281 20.1171C23.0111 20.434 22.5812 20.6121 22.133 20.6121H8.612C8.16375 20.6121 7.73386 20.434 7.4169 20.1171C7.09994 19.8001 6.92188 19.3702 6.92188 18.922V10.4714Z",
    stroke: "#8832F5",
    strokeWidth: 0.86167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3711 17.2344C16.7713 17.2344 17.9063 16.0994 17.9063 14.6992C17.9063 13.2991 16.7713 12.1641 15.3711 12.1641C13.971 12.1641 12.8359 13.2991 12.8359 14.6992C12.8359 16.0994 13.971 17.2344 15.3711 17.2344Z",
    fill: "#8832F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92188 12.1615C7.81837 12.1615 8.67815 11.8054 9.31207 11.1714C9.94599 10.5375 10.3021 9.67775 10.3021 8.78125M20.4429 20.6121C20.4429 19.7156 20.799 18.8558 21.4329 18.2219C22.0668 17.588 22.9266 17.2319 23.8231 17.2319",
    stroke: "#8832F5",
    strokeWidth: 0.86167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpr);
export default __webpack_public_path__ + "static/media/CPR.6a0ff23c374221a7edffbd0593ac5521.svg";
export { ForwardRef as ReactComponent };